<template>
  <section
    class="border-static-default-low flex items-center border-b px-16 py-8"
  >
    <div class="flex-1">
      <RevButtonIcon
        v-if="title"
        :icon="IconArrowLeft"
        variant="secondary"
        @click="$emit('back')"
      />
    </div>

    <div>
      <div
        v-if="title"
        class="heading-3 grow text-center"
        :style="{ color: color }"
      >
        {{ title }}
      </div>

      <TheLogo v-else class="flex h-16 flex-1 justify-center md:h-24" />
    </div>

    <div class="flex flex-1 justify-end">
      <RevButtonIcon
        :icon="IconCross"
        variant="secondary"
        @click="$emit('close')"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconArrowLeft } from '@ds/icons/IconArrowLeft'
import { IconCross } from '@ds/icons/IconCross'

import TheLogo from '~/scopes/navigation/components/TheLogo.vue'

defineProps<{ title?: string; color?: string }>()

defineEmits<{
  close: []
  back: []
}>()
</script>
